export default __webpack_public_path__ + "static/add-files-comments-buyer-view-786feb83a2fc5ea9121b51c8cac86d8d.png";